import { RootState } from "../../../redux-store";
import { createSelector } from "@reduxjs/toolkit";

export const selectWebBookers = (state: RootState) =>
  state.data.webBookers.webBookers;

export const selectWebBookersForClient = (clientId: string) =>
  createSelector(selectWebBookers, (webBookers) =>
    webBookers.filter((x) => x.clientId === clientId)
  );

export const selectWebBooker = (id: string) =>
  createSelector(selectWebBookers, (webBookers) =>
    webBookers.find((x) => x.id === id)
  );
